import { Output, EventEmitter, Directive, OnDestroy, OnInit } from '@angular/core';
import { ModelService } from '../../../Services/model.service';
import { LoginService } from 'app/Services/login.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { Macro } from 'app/Model/ui/Macro';

@Directive()
export abstract class UserActionBaseComponent implements OnInit, OnDestroy {
  @Output() userActionToggleStartButton = new EventEmitter<boolean>();
  @Output() userActionStarted = new EventEmitter<any>();

  constructor(public loginService: LoginService, public macroService: MacroService) {}

  get showPlaceHolders() {
    return this.loginService.showPlaceHolders;
  }

  public async canStartMacro() : Promise<boolean>{
    return true;
  }
  public  getActionId(macro:Macro): string{
    return macro.name;
  }

  public abstract createParameterStringAsJsonString(): string;
  public abstract parseParameter(parameter: string);

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }
}
